import React, { PureComponent } from 'react';
import InformationSection from '../../../../components/InformationSection';

class QuizToWin extends PureComponent {
	render() {
		const { priceToWin, locale, quizConfig } = this.props;
		return (
			<InformationSection>
				<InformationSection.Label>{locale['quiz.towin']}</InformationSection.Label>
				{priceToWin ? (
					<InformationSection.Value>
						{priceToWin}
						{quizConfig.valuta}
					</InformationSection.Value>
				) : (
					<InformationSection.Value>{locale['nothing.towin']}</InformationSection.Value>
				)}
			</InformationSection>
		);
	}
}

QuizToWin.propTypes = {};

QuizToWin.defaultProps = {};

export default QuizToWin;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/quizToWin/QuizToWin.component.js